/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('extrasNews.filter', function (el) {
        var newsFilter = new NewsFilter(el);
        newsFilter.run();
    });
    var NewsFilter = /** @class */ (function () {
        function NewsFilter(el) {
            this._BTN_ACTIVE_CLASS = 'btn-active';
            this.el = el;
        }
        NewsFilter.prototype.run = function () {
            this.bindSelect();
            this.bindButtonFilters();
        };
        NewsFilter.prototype.bindSelect = function () {
            var _this = this;
            this.el.querySelectorAll('select').forEach(function (select) {
                select.addEventListener('change', function () {
                    var params = [];
                    _this.el.querySelectorAll('select').forEach(function (s) {
                        if (s.value) {
                            params.push([s.dataset.key, s.value]);
                        }
                    });
                    _this.updateUrl(params);
                });
            });
        };
        NewsFilter.prototype.updateUrl = function (params) {
            var searchParams = new URLSearchParams(params);
            location.href = this.el.dataset.baseUrl + '?' + searchParams.toString();
        };
        NewsFilter.prototype.bindButtonFilters = function () {
            var _this = this;
            var buttons = this.el.querySelectorAll('button');
            buttons.forEach(function (button) {
                util.delegate(button, 'click', 'button', function () {
                    buttons.forEach(function (btn) {
                        if (btn !== button) {
                            btn.classList.remove(_this._BTN_ACTIVE_CLASS);
                        }
                    });
                    button.classList.toggle(_this._BTN_ACTIVE_CLASS);
                    var params = [];
                    var value = button.dataset.value;
                    var isActive = button.classList.contains('btn-active');
                    if (isActive && value !== '') {
                        params.push(['category', value]);
                    }
                    _this.updateUrl(params);
                });
            });
        };
        return NewsFilter;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
